import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { HeroSection } from "@/components/home/HeroSection";
import { TrustStrip } from "@/components/home/TrustStrip";
import { QuickEntrySection } from "@/components/home/QuickEntrySection";
import { UserSituationSection } from "@/components/home/UserSituationSection";
import { CareerPathwaysSection } from "@/components/home/CareerPathwaysSection";
import { FeaturesSection } from "@/components/home/FeaturesSection";
import { FreeEnglishSection } from "@/components/home/FreeEnglishSection";
import { ProgramTypesSection } from "@/components/home/ProgramTypesSection";
import { SkillstemCTA } from "@/components/home/SkillstemCTA";
import { DynamicProgramsSection } from "@/components/home/DynamicProgramsSection";
import { Seo } from "@/components/Seo";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Seo
        title="we-help.in | Free Career & Skill Guidance for Students, Graduates & Job-Seekers – A SkillSTEM Initiative"
        description="we-help.in, an initiative of SkillSTEM Academy LLP, helps Indian students, graduates, postgraduates, and job-seekers discover curated free education, skilling, and employability programs — from Class 12 through postgraduation and beyond. Government schemes, apprenticeships, online courses – listed from official sources."
        path="/"
      />
      <Header />
      <main className="flex-1">
        <HeroSection />
        <TrustStrip />
        <QuickEntrySection />
        <DynamicProgramsSection />
        <UserSituationSection />
        <CareerPathwaysSection />
        <FeaturesSection />
        <FreeEnglishSection />
        <ProgramTypesSection />
        <SkillstemCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
